export class Department {
  id: string;
  account_id: string;
  created_at: Date;
  description: string;
  name: string;
  updated_at: Date;
  total_members: number;
}
